/**
 * @module Featured Product Value Props
 * @description Featured Product Value Prosp
 */
import Tooltip from "@/blocks/Tooltip";

const features = {
  // Visa Reward Card
  vrc200: (
    <>
      $200 Visa Reward Card
      <span data-legal="visa-reward-offer" />{" "}
      <Tooltip disclosure="vrc-tooltip" placement="top" />
    </>
  ),

  // Contracts
  noContracts: "No long-term contracts",

  // Eero
  eeroCopper: (
    <>
      Amazon eero 6 router
      <span data-legal="eero" />
    </>
  ),
  eero500: (
    <>
      Amazon eero Pro 7 router
      <span data-legal="eero" />
    </>
  ),
  eeroGig: (
    <>
      Amazon eero Pro 7 Wi-Fi router
      <span data-legal="eero" />
    </>
  ),
  eero2Gig: (
    <>
      Amazon eero Pro 7 included
      <span data-legal="eero" />
    </>
  ),

  // devices
  severalDevices: "Work, stream and play on several devices",
  dozensOfDevices: "For smart homes with dozens of devices",

  // Benefits
  largeHomes: "Ultra-fast speeds for large smart homes",
  noDataCaps: (
    <>
      No data caps or overage charges{" "}
      <Tooltip disclosure="data-caps" placement="top" />
    </>
  ),
  yttv: (
    <>
      $10/mo. off Youtube TV for one year
      <span data-legal="youtubetv" />
      <Tooltip disclosure="tt-yttv" />
    </>
  ),
};

const valuePropMap = {
  /* -----------------------------------------------------------------------------
   *
   * Fiber Gig
   *
   * ----------------------------------------------------------------------------- */
  "fiber-gig": [features.dozensOfDevices, features.yttv, features.eeroGig],

  /* -----------------------------------------------------------------------------
   *
   * Fiber 500m
   *
   * ----------------------------------------------------------------------------- */
  "fiber-500m": [features.severalDevices, features.yttv, features.eero500],

  /* -----------------------------------------------------------------------------
   *
   * Fiber 2 Gig
   *
   * ----------------------------------------------------------------------------- */
  "fiber-2-gig": [
    features.largeHomes,
    features.vrc200,
    features.yttv,
    features.eero2Gig,
  ],

  /* -----------------------------------------------------------------------------
   *
   * Copper
   *
   * ----------------------------------------------------------------------------- */
  copper: [features.noDataCaps, features.noContracts, features.eeroCopper],
};

export default valuePropMap;
